import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';


import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';


@Injectable()
export class UserServices {
    patientData: any;
    httpOptions: any = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        })
    }
    constructor(private _http: HttpClient) { }


    getPatientsList(): Observable<any> {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "userid": loginUser.userDetail.id,
            "partnerid": loginUser.userDetail.partnerId,
            "token": loginUser.token,
            "isadmin": loginUser.isAdmin
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getPartnerOrderPatientsList", body, this.httpOptions)
            .catch(this.handleError);

    }



    // Method for Save new Coupon details
    varifyUser(couponForm): Observable<any> {
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        return this._http.post(environment.apiURL + "/api/varifyUser", couponForm)
            .catch(this.handleError);

    }

    searchPatients(searchText): Observable<any> {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "userid": loginUser.userDetail.id,
            "token": loginUser.token,
            "searchText": searchText,
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/filterPatients", body, this.httpOptions)
            .catch(this.handleError);

    }

    setPatientData(patientData: any) {
        this.patientData = patientData;
    }

    getPatientData() {
        return this.patientData
    }

     // Method for Save new Coupon details
     uploadLabResult(couponForm): Observable<any> {
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        return this._http.post(environment.apiURL + "/api/addLabReport", couponForm)
            .catch(this.handleError);

    }

    handleError(error: Response) {
        console.log(error);
        return Observable.throw(error);
    }
}